import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';
import Header from '../components/Header';
import Footer from '../components/Footer';

const TermsOfService: React.FC = () => {
  return (
    <Box sx={{ 
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      bgcolor: (theme) => theme.palette.mode === 'dark' ? 'background.default' : '#f8f9fa'
    }}>
      <Header />
      <Container maxWidth="md" sx={{ py: 4, flex: 1 }}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom>
            Terms of Service
          </Typography>
          
          <Typography variant="body1" paragraph>
            Last updated: {new Date().toLocaleDateString()}
          </Typography>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" gutterBottom>
              1. Acceptance of Terms
            </Typography>
            <Typography variant="body1" paragraph>
              By accessing and using Glowspirit's services, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" gutterBottom>
              2. Subscription Services
            </Typography>
            <Typography variant="body1" paragraph>
              Glowspirit offers subscription-based services with different tiers. Each subscription plan includes specific features and limitations as described in the plan details.
            </Typography>
            <Typography variant="body1" paragraph>
              Subscriptions are billed in advance on a monthly basis. You can cancel your subscription at any time, and you will continue to have access to the service until the end of your current billing period.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" gutterBottom>
              3. Payment Terms
            </Typography>
            <Typography variant="body1" paragraph>
              We accept payments through various payment providers including credit cards and PayPal. All payments are processed securely through our payment partners.
            </Typography>
            <Typography variant="body1" paragraph>
              By subscribing to our service, you authorize us to charge your payment method for the subscription fee and any applicable taxes.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" gutterBottom>
              4. Refund Policy
            </Typography>
            <Typography variant="body1" paragraph>
              Due to the digital nature of our services, we generally do not offer refunds for subscription fees. However, we may consider refunds in the following circumstances:
            </Typography>
            <Typography variant="body1" component="div" sx={{ pl: 2 }}>
              • Technical issues preventing service access that cannot be resolved within 48 hours<br />
              • Billing errors or duplicate charges<br />
              • Service unavailability for more than 24 consecutive hours
            </Typography>
            <Typography variant="body1" paragraph sx={{ mt: 2 }}>
              To request a refund, please contact our support team within 7 days of the charge. All refund requests will be reviewed on a case-by-case basis.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" gutterBottom>
              5. Service Usage
            </Typography>
            <Typography variant="body1" paragraph>
              You agree to use our services only for lawful purposes and in accordance with these Terms. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" gutterBottom>
              6. Termination
            </Typography>
            <Typography variant="body1" paragraph>
              We reserve the right to terminate or suspend your access to our services at any time, without notice, for any reason, including but not limited to violation of these Terms.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" gutterBottom>
              7. Changes to Terms
            </Typography>
            <Typography variant="body1" paragraph>
              We reserve the right to modify these Terms at any time. We will notify users of any material changes via email or through our website. Continued use of our services after such modifications constitutes acceptance of the updated Terms.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" gutterBottom>
              8. Contact Information
            </Typography>
            <Typography variant="body1" paragraph>
              If you have any questions about these Terms, please contact us at admin@glowspirit.org.
            </Typography>
          </Box>
        </Paper>
      </Container>
      <Footer />
    </Box>
  );
};

export default TermsOfService; 